import {
    IShowRealityCheckOptions
} from "../reality-check-presenter.interface";
import {DISPLAY_MESSAGE_IDS, DISPLAY_MESSAGE_NAMES} from "../../../../../../common/const/casinofied-analytics-consts";
import {
    GermanyRealityCheckDialogComponent
} from "../../../../../components/reality-check/germany/germany.reality-check-dialog.component";
import {RealityCheckDialogPresenterBase} from "../reality-check-dialog-presenter-base";
import {IModalDialogHandler} from "../../../../dialog/dialog.service.interface";

export class GermanyRealityCheckPresenter extends RealityCheckDialogPresenterBase {

    protected async _showDialog(options: IShowRealityCheckOptions, onDialogClosed: () => void): Promise<IModalDialogHandler> {
        let totalNetLoss = await this._getTotalNetLoss();

        await options.analytics.sendUniqueAnalyticsEvent('messageDisplay:show', async (corrId) => {
            this.services.casinofiedAnalytics.messageDisplay({
                displayMessageID: DISPLAY_MESSAGE_IDS.realityCheckGermany,
                displayMessageName: DISPLAY_MESSAGE_NAMES.REALITY_CHECK_GERMANY_MESSAGE_NAME,
                businessCorrelationID: corrId
            });
        })

        return this.services.dialog.showModal((dialogHandler) => {
            return (
                <GermanyRealityCheckDialogComponent dialogHandler={dialogHandler}
                                                    realityCheckAnalytics={options.analytics}
                                                    totalNetLoss={totalNetLoss}/>
            );
        }, {
            title: this.services.translation.translate('REALITY_CHECK_DIALOG_TITLE'),
            hideCloseButton: true,
            showPopupAboveSecondWebViewHybrid: true,
            disableFullscreenMobile: true,
            forceCentralization: true,
            isHighPriority: true,
            shouldBeClosedOnlyByUser: true,
            onClosed: () => {
                onDialogClosed();
            }
        })
    }

    private async _getTotalNetLoss(): Promise<number> {

        try {
            return (await this.services.api.userController.getRealityCheckData()).TotalNetLoss;
        } catch (err) {
            this.services.logger.error('Failed to get germany reality check data', err);
            return 0;
        }
    }
}